import React, { useState } from 'react';

const ExternalImage = ({
  filePath,
  aspectRatio,
  pictureStyle,
  style,
  ...otherProps
}) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <picture style={{ lineHeight: 0, ...pictureStyle }}>
      <img
        src={filePath}
        style={{
          maxInlineSize: '100%',
          blockSize: 'auto',
          aspectRatio: `${aspectRatio}`,
          objectFit: 'contain',
          width: '100%',
          height: 'auto',
          backgroundColor: isLoading ? 'rgba(0, 0, 0, 0.11)' : 'transparent',
          ...style,
        }}
        {...otherProps}
        onLoad={() => setIsLoading(false)}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src =
            'https://d2qd4lcg64wzid.cloudfront.net/ft_generic/no_photo.svg';
        }}
      />
    </picture>
  );
};

export default ExternalImage;
